import { MgpRadioBoxProps } from './MgpFormRadioBox.types';
import { accessJsonAttr } from '../../utils/utils';
import { useState } from 'react';


export default function MgpFormRadioBox({id, label, labelFontWeight, errors, register, ...props }: MgpRadioBoxProps)  {

    const [value, setValue] = useState(props.value);

    const onChangeEvent = (e: any) => {     
      if(props.onChange) {
          props.onChange(e);
      }
      setValue(e.currentTarget.value);
    }

    let fieldError;
    let inputClassName = "form-control";
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
            inputClassName += " form-error";
        }
    }
    return (
        <>
            <input type="radio" id={id} {...register(id, {onChange:(e) => {onChangeEvent(e)}} )} {...props} className={inputClassName} value={value}/>
            <label htmlFor={id} className="text">{label}</label>
        </>
  )
}
